import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';



export const INITIAL_STATE = Immutable({
    isLoading: false,
    status: false,
    error: ''
});



const resetState = (state, action) => {
    return state.merge({
        isLoading: false,
        status: false,
        error: ''
    });
};



const loadingState = (state, action) => {
    return state.merge({
        isLoading: true,
        status: false,
        error: ''
    });
};



const responseExpertQuery = (state, action) => {
    if(action.response.status) {
        return state.merge({
            isLoading: false,
            status: true
        });
    }

    else {
        return state.merge({
            isLoading: false,
            status: false,
            error: action.response.error
        });
    }
};



const ACTION_HANDLERS = {
    [Types.RESET_EXPERT_QUERIES]: resetState,
    [Types.POST_EXPERT_QUERIES]: loadingState,
    [Types.RESPONSE_EXPERT_QUERIES]: responseExpertQuery
};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)